enum CarrierEntryPoints {
  getSelect = '/api/select/carrier',
}

export default CarrierEntryPoints;
